import { FlexibleTableHeaderColumn } from "src/shared/components/data-display/FlexibleTable/flexible-table-items.interface"
import { HeaderProps } from "../../hooks/useHeaderProps"

// Valores tal como los espera el filtro del endpoint /reportes/tabla_ordenes
export const TIPOS_VENTA = {
    roomService: "Room service",
    restaurante: "Restaurante",
    mostrador: "Mostrador",
}

const useTipoVentaHeader = <T extends string>({
    headerValue,
    valueToDisplay,
}: HeaderProps<T>): FlexibleTableHeaderColumn => {
    const options = Object.values(TIPOS_VENTA).map((tipo) => ({
        value: tipo,
        valueToDisplay: tipo,
    }))

    return {
        value: headerValue,
        valueToDisplay,
        filterMenu: options,
        isFilterUnique: false,
        filterSuggetions: false,
    }
}

export default useTipoVentaHeader
